import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class IframeOriginGuard implements CanActivate {

  canActivate(): boolean {

    if (!window.location.ancestorOrigins) {

      // cannot really enforce this for unsupported browsers :|
      console.warn("Cannot verify origin is a Trello Board...");

      return true;
    }

    const parentOrigin = window.location.ancestorOrigins[0];

    if (parentOrigin
      && environment.allowedOrigins.length > 0
      && environment.allowedOrigins.includes(parentOrigin)) {
      return true;

    } else {
      console.error("This application can only be accessed via a Trello Board.");
      return false;
    }
  }
}
